export default __webpack_public_path__ + "static/media/vc_img.75ac1904.svg";